import React, {Component} from 'react';
import axios from 'axios';
import cookie from 'react-cookies';
import {Redirect} from 'react-router';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import Pagination from "react-js-pagination";
import Select from 'react-select';

import '../App.css';

import Chinese from '../translations/cn';
import English from '../translations/en';
import Japanese from '../translations/jp';
import Korean from '../translations/ko';
import German from '../translations/ge';
import French from '../translations/fr';
import Spanish from '../translations/sp';
import Italian from '../translations/it';
import Russian from '../translations/ru';
import Portuguese from '../translations/po';
import Hindi from '../translations/hi';
import Arabic from '../translations/ar';

export const dictionaryList = {
	English,
	Chinese,
	Japanese,
	Korean,
	German,
	French,
	Spanish,
	Italian,
	Russian,
	Portuguese,
	Hindi,
	Arabic
};

class Game extends Component{
	constructor(props){
		super(props);

		this.state = {
			activePage: 1,
			gameSlides: null,
			gameTypes: [],
			orgGameList: [],
			gameList: [],
			dataLanguage: dictionaryList['English'],
			isLogin: false,
			startNumber: 1,
			endNumber: 12,
			itemCountPerPage: 12,
			redirect: null,
			searchKeyword: '',
			startKeyword: '',
			showRequestGamePopup: false,
			gameTypeList: [],
			selectedGameType: null
		}		

		this.makeGameList = this.makeGameList.bind(this);
		this.getGameTypes = this.getGameTypes.bind(this);
		this.getGameList = this.getGameList.bind(this);
		this.changeGameTypeHandler = this.changeGameTypeHandler.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.setWrapperRefRequestPopup = this.setWrapperRefRequestPopup.bind(this);
	}
	
	componentWillMount(){
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
		if ( cookie.load('cookieId') ) {
			this.setState({
				isLogin: true
			})
		}

		this.getGameTypes();
		this.getGameTypeList();

		if ( localStorage.getItem('Language') ) {
			this.setState({
				dataLanguage: dictionaryList[localStorage.getItem('Language')]
			});
		} else {
			this.setState({
				dataLanguage: dictionaryList['English']
			});
		}
	}

	getGameTypes() {
		axios.get(window.$backend_url + '/getGameTypes')
			.then((response) => {
				this.setState({
					gameTypes : this.state.gameTypes.concat(response.data) 
				});

				this.getGameList();
		});
	}

	getGameList() {		
		axios.get(window.$backend_url + '/getActiveGameList')
			.then(response => {				
				if ( response.status === 200 ) {
					this.setState({
						gameList: []
					})

					this.setState({
						orgGameList: this.state.gameList.concat(response.data),
					});

					this.makeGameList();
				}
			})
	}

	makeGameList() {
		let tempList = [];

		for (var i=0; i<this.state.orgGameList.length; i++) {
			if (this.state.startKeyword) {
				if (this.state.orgGameList[i].name.toUpperCase().charAt(0) === this.state.startKeyword) {
					tempList.push(this.state.orgGameList[i]);
				}
			} else if (this.state.orgGameList[i].name.toLowerCase().includes(this.state.searchKeyword.toLowerCase())) {
				tempList.push(this.state.orgGameList[i]);
			}
		}

		this.setState({
			gameList: tempList,
			showRequestGamePopup: false
		},
		function(){
			
			let slider1 = this.state.gameList.map((game, index) => {			
				if (index >= (this.state.activePage - 1 ) * this.state.itemCountPerPage && index < this.state.activePage * this.state.itemCountPerPage ) {
					let gameBackStyle = {
						backgroundImage:  "url('/assets/images/games/" + game.main_image + "')"
					};

					index++;

					const filteredOptions = this.state.gameTypes.filter(
						(gameType) =>
						gameType.id === game.type
					);

					let typeName = '';
					let categoryName = "PC Game";

					if (filteredOptions.length) {
						typeName = filteredOptions[0].type;
						if (filteredOptions[0].category === 2)
							categoryName = "Mobile Game";
					}

					return(
							<div key={index} className="col-md-6">
								<div className="gameItem" onClick={this.goAssetPage.bind(this)}>
									<div className="row">
										<div className="col-6 back-image" style={gameBackStyle} rel={game.id}>
										</div>
										<div className="col-6 gameInfo">
											<p className="gameName" rel={game.id}>{game.name}</p>
											<p className="gameCategory">{categoryName}</p>
											<p className="gameType">{typeName}</p>
										</div>
									</div>
								</div>
							</div>
						)
				} else {
					return (null);
				}
			});

			if (this.state.gameList.length < this.state.itemCountPerPage) {
				this.setState({
					endNumber: this.state.gameList.length
				})
			}

			this.setState({
				gameSlides: null
			},
			function(){
				this.setState({
					gameSlides: slider1
				});
			})

			if ( tempList.length == 0 && this.state.searchKeyword ) {
				this.setState({
					showRequestGamePopup: true
				})
			}
		})
	}

	goAssetPage(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('gameId', e.target.getAttribute('rel'));

			this.props.history.push('/assets');
			// this.setState({ redirect: "/assets" });
		}
	}

	searchGame(e) {
		this.setState({
			searchKeyword: '',
			startKeyword: e.target.value,
			startNumber: 1,
			activePage: 1
		}, function(){
			this.makeGameList();
		})
	}

	initSearchKeyword = (e) => {
		this.setState({
			startKeyword: ''
		}, function () {
			this.makeGameList();
		});
	}

	searchKeywordChangeHandler = (e) => {
		this.setState({
			searchKeyword: e.target.value,
			startKeyword: '',
			startNumber: 1,
			activePage: 1
		}, function () {
			this.makeGameList();
		});
	}

	setLanguage(lang) {
		this.setState({
			dataLanguage: dictionaryList[lang]
		})
	}

	checkLogin() {
		if ( cookie.load('cookieId') ) {
			this.setState({
				isLogin: true
			})
		} else {
			this.setState({
				isLogin: false
			})
		}
	}

	handlePageChange(pageNumber) {
		this.setState({
			activePage: pageNumber,
			startNumber: (pageNumber - 1) * this.state.itemCountPerPage + 1,
			endNumber: pageNumber * this.state.itemCountPerPage,
		});

		if (pageNumber * this.state.itemCountPerPage > this.state.gameList.length) {
			this.setState({
				endNumber: this.state.gameList.length
			})
		}

		this.getGameTypes();

		window.scrollTo(0, this.refs.game_list.offsetTop - 30);
	}

	// ===== Request Game =====

	sendRequestGame(e) {
		e.preventDefault();
		
		if (this.state.searchKeyword && this.state.selectedGameType) {
			const gameData = {
				userId: cookie.load('cookieId'),
				title : this.state.searchKeyword,
				gameType: this.state.selectedGameType
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/sendRequestGame', gameData)
				.then(response => {
					if(response.status === 200){
						this.setState({
							showRequestGamePopup: false
						})
					}
				})
				.catch(error => {
					this.setState({
						showRequestGamePopup: false
					})
				})
		}

		this.setState({
			searchKeyword: '',
			showRequestGamePopup: false
		})
	}

	setWrapperRefRequestPopup(node) {
		this.searchPopup = node;
	}

	handleClickOutside(event) {
		if (this.searchPopup && !this.searchPopup.contains(event.target)) {
			this.setState({
				showRequestGamePopup: false
			})
		}
	}

	changeGameTypeHandler = selectedGameType => {
		this.setState({ 
			selectedGameType: selectedGameType
		})
	}

	getGameTypeList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameTypes')
			.then(response => {
				if ( response.status === 200 ) {
					var gameTypeList = [];

					for (var i=0; i<response.data.length; i++) {
						gameTypeList.push({ value: response.data[i].id, label: response.data[i].type });
					}
					
					this.setState({
						gameTypeList: gameTypeList
					});
				}
			})
	}

	render(){
		if (this.state.redirect) {
			return <Redirect to={this.state.redirect} />
		}

		const customStyle = {
      control: styles => ({ 
        ...styles,
        backgroundColor: 'white',
        color: 'black',
        border: 'solid 3px #ffd33f',
        borderRadius: '20px',
        paddingLeft: '7px',
        paddingRight: '7px',
        boxShadow: 'none',
        outline: 'none',
        "&:hover": {
          color: 'white',
          outline: 'none',
          boxShadow: 'none'
        },
        "&:focus": {
          color: 'white',
          outline: 'none',
          boxShadow: 'none'
        }
      }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
          backgroundColor: isFocused ? '#ddd' : 'white',
          color: isFocused ? 'black' : 'gray',
          padding: '10px 15px',
          size: 5,
          "&:hover": {
            border: 'none',
            boxShadow: 'none',
            outline: 'none'
          },
          "&:focus": {
            border: 'none',
            boxShadow: 'none',
            outline: 'none'
          }
        };
      },
      container: (base, state) => ({
        ...base,
        border: state.isFocused ? null : null,
        "&:hover": {
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        },
        "&:focus": {
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        }
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "black",
        "&:hover": {
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        },
        "&:focus": {
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        }
      })
    }
		
		return(
			<div className="digit game">
				<Header history={this.props.history} ref="header" dataLanguage={this.state.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="4" dataLanguage={this.state.dataLanguage} history={this.props.history} header={this.refs.header} />
							
							<div className="banner-slider">
								<div className="owl-slider">
									<OwlCarousel items={1} className="owl-theme" loop nav margin={1} >
										<div><img alt="" className="img" src= {'/assets/images/popular-game-main.jpg'}/></div>
									</OwlCarousel>
								</div>
							</div>
							<div className="search-container-out">
								<div className="search-container game-search">
									<div className="form">
										<input name="search" placeholder={this.state.dataLanguage['search_games']} type="text" value={this.state.searchKeyword} onChange={this.searchKeywordChangeHandler} />
										<button onClick={this.initSearchKeyword}><img alt="" src="/assets/images/search-icon.png" /></button>
									</div>
									{this.state.showRequestGamePopup ?
										<div ref={this.setWrapperRefRequestPopup} className="game_request">
											<div className="form-group">
												<input className="gameTitle" name="Title" placeholder="Title" type="text" value={this.state.searchKeyword} onChange={this.searchKeywordChangeHandler} />
												<Select id="Genre" styles={customStyle} options={this.state.gameTypeList} onChange={this.changeGameTypeHandler} value={this.state.selectedGameType} placeholder={this.state.dataLanguage['genre']} />
											</div>
											<div className="text-right">
												<button className="btn_yellow" onClick={this.sendRequestGame.bind(this)}>{this.state.dataLanguage['request_game']}</button>
											</div>
										</div>
									: null}
								</div>
								<div className="alpahbet-buttons text-center">
									<button onClick={this.searchGame.bind(this)} value="">{this.state.dataLanguage['all']}</button>
									<button onClick={this.searchGame.bind(this)} value="A">A</button>
									<button onClick={this.searchGame.bind(this)} value="B">B</button>
									<button onClick={this.searchGame.bind(this)} value="C">C</button>
									<button onClick={this.searchGame.bind(this)} value="D">D</button>
									<button onClick={this.searchGame.bind(this)} value="E">E</button>
									<button onClick={this.searchGame.bind(this)} value="F">F</button>
									<button onClick={this.searchGame.bind(this)} value="G">G</button>
									<button onClick={this.searchGame.bind(this)} value="H">H</button>
									<button onClick={this.searchGame.bind(this)} value="I">I</button>
									<button onClick={this.searchGame.bind(this)} value="J">J</button>
									<button onClick={this.searchGame.bind(this)} value="K">K</button>
									<button onClick={this.searchGame.bind(this)} value="L">L</button>
									<button onClick={this.searchGame.bind(this)} value="M">M</button>
									<button onClick={this.searchGame.bind(this)} value="N">N</button>
									<button onClick={this.searchGame.bind(this)} value="O">O</button>
									<button onClick={this.searchGame.bind(this)} value="P">P</button>
									<button onClick={this.searchGame.bind(this)} value="Q">Q</button>
									<button onClick={this.searchGame.bind(this)} value="R">R</button>
									<button onClick={this.searchGame.bind(this)} value="S">S</button>
									<button onClick={this.searchGame.bind(this)} value="T">T</button>
									<button onClick={this.searchGame.bind(this)} value="U">U</button>
									<button onClick={this.searchGame.bind(this)} value="V">V</button>
									<button onClick={this.searchGame.bind(this)} value="W">W</button>
									<button onClick={this.searchGame.bind(this)} value="X">X</button>
									<button onClick={this.searchGame.bind(this)} value="Y">Y</button>
									<button onClick={this.searchGame.bind(this)} value="Z">Z</button>
								</div>
							</div>							

							<div ref="game_list" className="game-list">
								{this.state.gameSlides ?
									<div className="row">
										{this.state.gameSlides}
									</div>
								: null }
							</div>
							<div className="paginationContainer">
								<div className="row">
									<div className="col-md-6">
										{ this.state.gameList.length ?
											<p className="paginationText">{this.state.dataLanguage['showing']} {this.state.startNumber}-{this.state.endNumber} {this.state.dataLanguage['of']} {this.state.gameList.length} {this.state.dataLanguage['results']}</p>
										:
											<p className="paginationText">0 {this.state.dataLanguage['result']}</p>
										}
									</div>
									<div className="col-md-6 text-right">
										{ this.state.gameList.length ?
											<Pagination
											  activePage={this.state.activePage}
											  itemsCountPerPage={this.state.itemCountPerPage}
											  totalItemsCount={this.state.gameList.length}
											  pageRangeDisplayed={5}
											  itemClass="btnPagination"
											  itemClassFirst="btnControl"
											  itemClassLast="btnControl"
											  itemClassNext="btnControl"
											  itemClassPrev="btnControl"
											  prevPageText="<"
											  nextPageText=">"
											  onChange={this.handlePageChange.bind(this)}
											/>
										: null }
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
				<Footer dataLanguage={this.state.dataLanguage} header={this.refs.header} />
			</div>
		)
	}
}

export default Game;


// WEBPACK FOOTER //
// ./src/components/Game.js